import AuthApi from '@/api/auth-api'
import LocalStorageFactory from '@/factories/local-storage-factory'
import { USER_TYPE_HG_ADMIN_GROUP } from '@/configs/constant'

/**
 * @param {string} companyCode
 * @param {string} username
 * @param {string} password
 * @param {string} otp
 * @returns {
 * Promise<{
 * companyData: object,
 * companyList: Array<object>,
 * isRequireOtp: boolean,
 * profile: object,
 * token: string
 * }>}
 */
const login = async (companyCode, username, password, otp) => {
  const result = await AuthApi.auth(companyCode, username, password, otp)

  const profile = result.profile
  const userDetail = _initUserDetail(profile)
  const companyDetail = result.companyData

  LocalStorageFactory.setUserDetail(userDetail)
  LocalStorageFactory.setToken(result.token)

  const isHGAdmin = USER_TYPE_HG_ADMIN_GROUP.includes(Number(profile.userTypeId))
  if (isHGAdmin) {
    let companyList = result.companyList
    LocalStorageFactory.setCompanyList(companyList)
  }

  LocalStorageFactory.setCompanyDetail(companyDetail)

  return result
}

const checkRequireOtp = async (username) => {
  const result = await AuthApi.checkRequireOtp(username)

  return result.isRequireOtp
}

function _initUserDetail (profile) {
  return {
    username: profile.username,
    firstName: profile.firstName,
    lastName: profile.lastName,
    userTypeId: Number(profile.userTypeId)
  }
}

export default {
  login,
  checkRequireOtp
}
